import { getAppConfig } from "services/configService";
import { POST, rawPOST } from "services/httpService";
import urlJoin from "url-join";

const apiUrl = () => {
  return getAppConfig().AuthApiUrl;
};

export const deleteAccount = (requestInfo, idp, idpSubId, channel) => {
  return POST(requestInfo, urlJoin(apiUrl(), `v2/identities/${idp}/${idpSubId}/deleteaccount`), { channel });
};

export const confirmDeleteAccount = (requestInfo, idp, idpSubId, confirmationToken) => {
  return POST(
    requestInfo,
    urlJoin(apiUrl(), `v2/identities/${idp}/${idpSubId}/deleteaccount/${confirmationToken}/actions/confirm`)
  );
};

export const changeEmail = async (requestInfo, idp, idpSubId, email, channel) => {
  const res = await rawPOST(requestInfo, urlJoin(apiUrl(), `v2/identities/${idp}/${idpSubId}/emailchanges`), {
    email,
    channel
  });

  if (res.status === 409) {
    return { success: false };
  }

  return { success: true, response: res.json() };
};

export const confirmChangeEmail = (requestInfo, idp, idpSubId, confirmationToken) => {
  return POST(
    requestInfo,
    urlJoin(apiUrl(), `v2/identities/${idp}/${idpSubId}/emailchanges/${confirmationToken}/actions/confirm`)
  );
};
